<!-- 大标题+副标题+按钮+蒙版+背景图 -->
<template>
	<!-- ai -->
	<div style="position: relative; height: 500px;">
		<div v-if="!hidemb"
			style="position:absolute; text-align: center; width: 100%; height: 500px;opacity: 0.8;z-index: 2;"
			v-bind:style="styleObjectmengbang">
		</div>
		<div style="height: 100%; position:absolute;text-align: center; width: 100%; z-index: 2; ">
			<div style="height:28% ;"> </div>
			<transition name="adfade">
				<div v-if="showword" class="fontsize1" style="font-weight: 700; color: #FFFFFF; "
					v-bind:style="styleObject">
					{{title}}
				</div>
			</transition>
			<transition name="adfade">
				<div v-if="title2&&showword"
					style="font-weight: 700; color: #FFFFFF; "
					v-bind:style="styleObject">
					{{title2}}
				</div>

			</transition>
			<transition name="adfade">
				<div v-if="subtitle&&showword"
					style="font-size: 16px; margin-top: 20px; letter-spacing: 10px;color: #FFFFFF;opacity: 0.7;text-transform :uppercase; "
					v-bind:style="styleObject">
					{{subtitle}}
				</div>
			</transition>
			<transition name="adfade2">
				<button v-if="button&&showword" v-on:click="gopage()"
					style=" font-size: 13px; border: 1px solid #FFFFFF;color: #FFFFFF; margin-top: 30px;margin-left: auto;margin-right: auto; width: 108px; height: 32px;rgba(255, 255, 255, 0.2);"
					v-bind:style="styleObjectbutton">
					{{button}}
					<!-- {{pagetop>thiseltop}}-	{{pagetop}}-	{{thiseltop}} -->
				</button>
			</transition>
		</div>
		<div style="width: 100%;overflow: hidden;z-index: 1;">
			<img :class="[showword?'ballon':'ballon2']" class="bakimg" :src="imgurl" />
			<!-- :class="[showword?'ballon1':'ballon2']" -->
		</div>

	</div>
	<!-- ai end-->
</template>

<script>
	export default {
		name: 'adBigWordButton',
		props: ['title', 'title2', 'subtitle', 'button', 'stylemode', 'imgurl', 'hidemb', 'pagetop', 'buttonurl'],
		data() {
			return {
				showword: false,
				styleObject: {
					color: '#FFFFFF',
				},
				styleObjectbutton: {
					background: 'rgba(255, 255, 255, 0.2)',
					opacity: 1,

				},
				styleObjectmengbang: {
					backgroundColor: '#263E8B',

				},
				thiseltop: 0,
			}
		},
		watch: {
			'pagetop': function(newval) {
				if (!this.showword) {

					var pl = document.documentElement.clientHeight / 4
					if (newval + pl > this.thiseltop) {
						this.showword = true
					}
				}
			},

		},
		mounted() {
			var _this = this
			_this.thiseltop = this.$el.offsetTop
			// 多进行一次复制 这样可以确保准确
			setTimeout(() => {
				_this.thiseltop = this.$el.offsetTop
			}, 500);

			if (this.stylemode == 'blue') {
				this.styleObject.color = '#263E8B'
				this.styleObjectbutton.background = '#263E8B'
				this.styleObjectbutton.borderColor = '#263E8B'
				this.styleObjectbutton.border = '1 px solid #263E8B'
				this.styleObjectmengbang.backgroundColor = "#ffffff"
			} else if (this.stylemode == 'brown') {

				this.styleObjectmengbang.backgroundColor = "#6C4B34"

			}

		},
		methods: {

			gopage: function() {
				var _this = this
				this.$router.push(this.buttonurl)

				//回到顶部
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
			},

		},

	}
</script>

<style>
	@media (min-width: 1px) {
		.fontsize1 {
			letter-spacing: 5px;
			font-size: 30px;
	
		}
	}
	
	@media (min-width: 1000px) {
		.fontsize1 {
			letter-spacing: 10px;
			font-size: 70px;
	
		}
	}
	
	
	.adfade-enter-active {
		transition: all 2s;
	}

	.adfade-enter {
		opacity: 0;
		transform: translateY(-20px);
	}

	.adfade2-enter-active {
		transition: all 2s;
	}

	.adfade2-enter {
		opacity: 0;
		transform: translateY(20px);
	}



	.bakimg {
		width: 100%;
		object-fit: cover;
		height: 500px;

	}

	.ballon {

		animation-name: scaledraw;
		animation-duration: 1.8s;
	}

	.ballon2 {


		transform: scale(1.8);

	}

	@keyframes scaledraw {
		0% {
			transform: scale(1.8);
		}

		100% {
			transform: scale(1);
		}
	}
</style>
